<template>
    <div class="copyrightRegistration">
        <div class="container">
            <div class="timeline_box">
                <Timeline :data="TimelineData"></Timeline>
            </div>

            <ul class="main_group">
                <li class="main_item">
                    <span class="item_title top">作品样本：</span>
                    <div class="item_content">
                        <div class="radio_box">
                            <RadioGroup>
                                <Radio label="金斑蝶"><span>本地上传</span></Radio>
                                <Radio label="爪哇犀牛"><span>从我的存证选择</span></Radio>
                            </RadioGroup>
                        </div>

                        <div class="upload_group">
                            <div class="upload_works_box">
                                <MyUploadOneHw
                                        :width="175"
                                        :height="154"
                                        border="1px dashed #B9B9B9"
                                        addIcon="addFile"
                                        tipsText="点击或拖拽上传文件"
                                        preImg=""
                                        @listenImgUrl="showMessageFromWorksChild"></MyUploadOneHw>

                                <div class="upload_works_text">
                                    <div>温馨提示：</div>
                                    <ol class="upload_works_text_group">
                                        <li>1、一次只能上传一个文件；</li>
                                        <li>2、不同类型上传文件大小不同，分别如下: 文档类：20M，图片类：100M，音视频类：500M，其他：200M；</li>
                                        <li>3、登记成功后将获得电子版登记证书；</li>
                                    </ol>
                                </div>
                            </div>

                        </div>
                    </div>
                </li>
                <li class="main_item">
                    <span class="item_title">作品名称：</span>
                    <div class="item_content">
                        <Input placeholder="作品名称需与作品样本内作品名称保持一致"/>
                    </div>
                </li>
                <li class="main_item">
                    <span class="item_title">作品类型：</span>
                    <div class="item_content">
                        <div>创意想法</div>
                        <div></div>
                    </div>
                </li>
            </ul>

        </div>

    </div>
</template>

<script>
    import MyUploadOneHw from '@/views/main-components/my-upload-one-hw';
    import Timeline from '@/views/main-components/horizontal-timeline';

    export default {
        name: "copyrightRegistration",
        components: {
            MyUploadOneHw,
            Timeline,
        },
        data() {
            return {
                TimelineData: [
                    {name: '选择作品', state: 2},
                    {name: '完善信息', state: 1},
                    {name: '信息审核', state: 0},
                    {name: '颁发证书', state: 0}
                ]
            }
        },
        methods: {
            showMessageFromWorksChild() {

            }
        }
    }
</script>

<style scoped lang="less">
    ol, ul {
        list-style: none;
    }

    .container {
        width: 1334px;
        margin: 0 auto;
    }

    .timeline_box {
        padding: 40px 0 62px;
    }

    .main_group {
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px;
    }

    .main_group .main_item {
        display: flex;
        padding: 20px 40px;
        font-size: 14px;
        border-bottom: 1px solid #EEEEEE;

        .item_title {
            width: 122px;
            align-self: center;
        }

        .item_title.top{
            align-self: auto;
        }

        .item_content {
            flex: 1;
        }
    }

    .radio_box .ivu-radio-wrapper {
        color: #333;
        margin-right: 20px;
        width: 136px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        border: 1px solid #B9B9B9;
        border-radius: 4px;
    }

    .radio_box .ivu-radio-wrapper span {
        color: #999999;
    }

    .radio_box .ivu-radio-wrapper.ivu-radio-wrapper-checked {
        border: 1px solid #000000;
    }

    .radio_box .ivu-radio-wrapper.ivu-radio-wrapper-checked span {
        color: #333333;
    }

    /deep/ .radio_box .ivu-radio {
        display: none;
    }

    .upload_group {
        padding-top: 20px;

        .upload_works_box:last-child {
            padding-bottom: 0;
            border-bottom: none;
        }
    }

    .upload_works_box {
        display: flex;
        padding-bottom: 20px;
        border-bottom: 1px solid #EEEEEE;

        .upload_works_text {
            align-self: flex-end;
            margin-left: 20px;
            color: #999999;
            font-size: 14px;
        }

        .upload_works_text_group {
            padding-top: 10px;
        }
    }

    /deep/ .ivu-input {
        width: 434px;
        height: 38px;
        /*border: 1px solid #CBCBCB;*/
        border-radius: 2px;
        box-shadow: none;
        font-size: 12px;
        line-height: 38px;
        color: #3A3A3A;
        padding: 0 10px;
    }

    /deep/ .ivu-input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #999999;
    }

    .ivu-input::-moz-placeholder { /* Firefox 19+ */
        color: #999999;
    }

    .ivu-input:-ms-input-placeholder { /* IE 10+ */
        color: #999999;
    }

    .ivu-input:-moz-placeholder { /* Firefox 18- */
        color: #999999;
    }
</style>